













import ecAreaImport from '../../../dv-pure-render/ec-area/ec-area.js';
let ecArea:any = ecAreaImport;
import {Vue, Component, Watch, Prop} from 'vue-property-decorator';
import lang2d from '../../../utils/lang/lang-2d.js';

@Component({
    components: {}
})
export default class PoiRightArea extends Vue {
    lang:any = lang2d;
    animation = autoAnimation ? 'fly-out' : 'fly-in';
    @Prop()
    data: any;
    ecArea: any;

    @Watch('data', {immediate: true,})
    onValueChange(newVal: any, oldVal: any) {
        Vue.nextTick(() => {
            this.draw();
        });
    }

    draw () {
        if (this.animation === 'fly-out') {
            return void 0;
        }
        let data = this.data;
        data.tip = this.lang.commentCount2;
        this.destroyChart();
        this.ecArea = ecArea({
            dom: this.$refs.mountNode,
            data: data,
            G2,
            echarts,
        });
    }

    destroyChart () {
        this.ecArea && this.ecArea.destroy();
        this.ecArea = null;
    }

    beforeDestroy () {
        this.destroyChart();
    }

    mounted () {
        console.log('poi-right-area');
        this.$autoOn('poi-right-area', async () => {
            this.animation = 'fly-in';
            this.draw();
            await this.$sleep(1000);
        });
    }
}
